import { render, staticRenderFns } from "./AssignButton.vue?vue&type=template&id=a0fc5c76&"
import script from "./AssignButton.vue?vue&type=script&lang=ts&"
export * from "./AssignButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports